export const API_REQUEST = 'API_REQUEST';

export const apiRequest = (method, path, data = null, successHandler = null, errorHandler = null, successCallback = null) => {
  return {
    type: API_REQUEST,
    path: path,
    method: method,
    data: data,
    successHandler: successHandler,
    errorHandler: errorHandler,
    successCallback: successCallback,
  };
};
